import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { Accordion } from '../../../subcomponents/accordion/accordion';
import { HeadingLevel } from '../../../subcomponents/heading/heading';
import { CompositeFilterAccordionSection } from './accordion-section';
const b = bemClassBuilder('v-composite-filter-accordion');
export const CompositeFilterAccordion = observer(props => {
    const { filter, sectionsToDisplay, displayText, cdnOptions } = props;
    return (_jsx(Accordion, Object.assign({ className: b.block(), headingLevel: HeadingLevel.H5 }, { children: sectionsToDisplay.map(({ key }) => {
            var _a;
            const isMultiselect = !!((_a = sectionsToDisplay.find(f => f.key === key)) === null || _a === void 0 ? void 0 : _a.isMultiselect);
            const options = filter.sections[key].options;
            if (!options)
                return null;
            return (_jsx(CompositeFilterAccordionSection, { className: b.element('section'), filterKey: key, options: options, isMultiselect: isMultiselect, displayText: displayText, cdnOptions: cdnOptions, onChange: props.onChange, expandedByDefault: props.expandAccordionSectionsByDefault || false }, key));
        }) })));
});
CompositeFilterAccordion.displayName = 'CompositeFilterAccordion';
